<template lang="pug">
  .price-batch
    h4.price-batch__form-header Изменить цены на все материалы данного типа
    ValidationObserver(
      v-slot="{ invalid }"
      ref="observer"
    )
      form.price-batch__form(
        v-promise-btn="{action: 'submit'}"
        @submit.prevent="updatePrice"
      )
        ValidationProvider(
          rules="required"
          v-slot="{ errors }"
          ref="subtype-provider"
        )
          .price-batch__form-input-wrapper
            select.price-batch__form-input(
              v-model="selectedSubtypeId"
            )
              option(value="-1") Все типы
              option(v-for="subtype in type.subtypes" v-bind:value="subtype.id")
                | {{ subtype.title }}
            span.form-error {{ errors[0] }}
        ValidationProvider(
          rules="numeric|required"
          v-slot="{ errors }"
          ref="cost-provider"
        )
          .price-batch__form-input-wrapper
            input.price-batch__form-input(
              v-model="price"
              placeholder="Новая цена"
            )
            span.form-error {{ errors[0] }}
        button.btn.price-batch__form-submit(
          type="submit"
          :disabled="invalid"
        ) Изменить цены
</template>

<script>
import { mapState } from 'vuex';
import store from '@/store/store';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';

export default {
  props: {
    groupId: {
      required: true,
      type: Number
    },
    typeId: {
      required: true,
      type: Number
    },
    type: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      selectedSubtypeId: -1,
      price: null
    };
  },

  computed: {
    ...mapState({
      firmId: state => state.user.profile.id
    })
  },

  methods: {
    updatePrice() {
      return this.$refs.observer.validate().then(success => {
        if (!success) {
          return;
        }
        const subtype =
          Number(this.selectedSubtypeId) !== -1 ? this.selectedSubtypeId : null;

        const updatePromise = store.dispatch('updateMaterialTypePriceBatch', {
          firmId: this.firmId,
          data: {
            materialTypeId: this.typeId,
            materialSubtypeId: subtype,
            price: this.price
          }
        });
        updatePromise.then(() => {
          this.flashSuccess('Цены материалов изменены');
          this.$emit('updatePrice', this.typeId);
        });
        return updatePromise;
      });
    }
  },

  components: {
    ValidationProvider,
    ValidationObserver
  }
};

// Validation rules
extend('required', {
  ...required,
  message: 'Обязательно'
});

extend('numeric', {
  ...numeric,
  message: 'Может содержать только цифры'
});
</script>

<style lang="scss" scoped>
.price-batch {
  &__form {
    margin: 0 0 1em -10px;
    display: flex;
    align-items: flex-start;
  }

  &__form-input-wrapper {
    margin-left: 10px;
  }

  &__form-input,
  &__form-input input {
    height: 38px;
    width: 180px;
  }

  &__form-submit {
    margin: 0 0 0 10px;
  }
}
@media screen and (max-width: 480px) {
  .price-batch {
    &__form {
      flex-wrap: wrap;
    }
    &__form-input {
      margin-bottom: 10px;
    }
  }
}
</style>
